module.exports = __webpack_public_path__ + "static/one-req-one-res-016e9ee7ef5856a537a523a142104815.png";